import * as React from "react";
import { connect } from "react-redux";
import { IdPersistence } from "../../constants/IdPersistence";
import { IdStyles } from "../../less/IdStyles";
import { selectCoopLevel } from "../../selectors/selectCoopInfo";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { ReplacementLoca } from "../../utils/i18n/ReplacementLoca";
import { PlayerPreferencesPlatformType } from "../../utils/network/generated/protoTypes";
import { utilNumber } from "../../utils/utilNumber";
import { TextLoca } from "../generic/text/TextLoca";
import { actionModalClose } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { actionServerPersistenceSetInfo } from "../server-persistence/actionServerPersistence";
import { DialogGenericLevelUp } from "../xp/DialogGenericLevelUp";
var DialogCooperativeLevelUpDOM = function (_a) {
    var level = _a.level, onClose = _a.onClose;
    var replacements = new Map([
        [ReplacementLoca.zero_0, level.toString()],
    ]);
    return (React.createElement(DialogGenericLevelUp, { level: level, onClose: function () { return onClose(level); } },
        React.createElement("div", { className: IdStyles.CooperativeLevelUpText + " coop-level-up" },
            React.createElement(TextLoca, { id: IdLoca.coopSystemMessage_coopLevelUp, replacements: replacements, className: IdStyles.TextBoldSecondaryOutline }))));
};
var mapState = function (state) { return ({
    level: selectCoopLevel(state),
}); };
var mapDispatch = function (dispatch) { return ({
    onClose: function (level) {
        dispatch(actionServerPersistenceSetInfo({
            key: IdPersistence.CoopPreviousLevel,
            platform: PlayerPreferencesPlatformType.PLAT_SHARED,
            value: utilNumber.format(level),
        }));
        dispatch(actionModalClose(IdModal.CooperativeLevelUp));
    },
}); };
export var DialogCooperativeLevelUp = connect(mapState, mapDispatch)(DialogCooperativeLevelUpDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/DialogCooperativeLevelUp.tsx
// module id = 2556
// module chunks = 3